module.exports = __webpack_public_path__ + "7b1aa08f8e8f7685e2918a553bf9b368.png";